<template>
  <a-card :bordered="false">
    <a-spin :spinning="loading">
      <a-form :form="form" class="table-page-search-wrapper">
        <a-row>
          <a-col :span="24" v-if="sellContract">
            <a-divider orientation="left">
              关联信息
            </a-divider>
          </a-col>
          <a-col :span="12" v-if="sellContract">
            <a-form-item label="采销全流程" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              {{ sellContract.project }}
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="sellContract">
            <a-form-item label="货物" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              {{ sellContract.product_name }}
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="sellContract">
            <a-form-item label="合同号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              {{ sellContract.number }} [ {{ sellContract.name }}]
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              信用证付款信息
            </a-divider>
          </a-col>
          <a-col :span="24">
            <a-form-item label="业务号" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-input v-decorator="['business_no', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="mdl && mdl['issuing_bank']">
            <a-form-item label="开证银行" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <span>{{ mdl['issuing_bank'] }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="代开银行" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :filter-option="false"
                :not-found-content="bankFetching ? undefined : null"
                show-search
                allow-clear
                v-decorator="[
                  'debtor_bank_id',
                  {
                    rules: [
                      { required: true, message: '必填项，请填写信息' },
                    ],
                  },
                ]"
                placeholder="请输入银行名称"
                :default-active-first-option="false"
                @search="this.bankSearch"
              >
                <a-spin v-if="bankFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in bankList" :key="d.id" :value="d.id">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="sellContract">
            <a-form-item label="受益人" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <span>{{ sellContract['client'] }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="开证日" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-date-picker
                v-decorator="['issue_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="开证日"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="开证金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" v-decorator="['lc_amount', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="金额"/>
              <a-select
                style="width: 50%"
                allow-clear
                v-decorator="[
                  'lc_amount_currency',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择币种"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="溢短装" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" style="width: 50%" v-decorator="['more_less_clause', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="溢短装"/> %
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="保证金存入日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-date-picker
                v-decorator="['margin_deposit_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="保证金存入日期"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="保证金金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" v-decorator="['margin_amount', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="金额"/>
              <a-select
                style="width: 50%"
                allow-clear
                v-decorator="[
                  'margin_amount_currency',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择币种"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="保证金到期日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-date-picker
                v-decorator="['margin_maturity_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="保证金到期日期"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="保证金利率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['margin_interest_rate', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="保证金利率"/> %
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="到期可用" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-switch v-decorator="['is_available_at_expiry', { initialValue: false, valuePropName: 'checked' }]" checked-children="是" un-checked-children="否"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="信用证种类" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                allow-clear
                v-decorator="[
                  'lc_type',
                  {
                    rules: [
                      { required: true, message: '请选择' },
                    ],
                  },
                ]"
                placeholder="请选择"
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in lcTypeList">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="信用证期限" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number style="width: 50%" v-decorator="['lc_tenor', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="信用证期限"/> 天
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-row>
              <a-col span="4" :offset="8">
                <a-button type="primary" html-type="submit" @click="handleSubmit" :loading="submitting">提交</a-button>
              </a-col>
              <a-col span="12">
                <a-button @click="handleGoBack">返回</a-button>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-card>
</template>

<script>
import moment from 'moment'
import {
  lc_application_list,
  lc_issuance_list,
  lc_issuance_update
} from '@/api/trade_credit_letter'
import pick from 'lodash.pick'
import debounce from 'lodash/debounce'
import { bank_list } from '@/api/trade_bank'
import { sell_contract_list } from '@/api/trade_sell_contract'
const fields = ['id', 'business_no', 'debtor_bank_id', 'issue_date', 'lc_amount', 'lc_amount_currency', 'more_less_clause', 'margin_deposit_date',
  'margin_amount', 'margin_amount_currency', 'margin_maturity_date', 'margin_interest_rate', 'is_available_at_expiry', 'lc_type', 'lc_tenor']
export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    this.bankSearch = debounce(this.handleBankSearch, 800)
    return {
      formLayout: 'horizontal',
      form: this.$form.createForm(this),
      sellContract: undefined,
      mdl: undefined,
      id: 0,
      currency: this.$Dictionaries.currency,
      tradePaymentRelatedContract: this.$Dictionaries.trade_related_contract,
      contractTypes: this.$Dictionaries.contractTypes,
      bankServicesTypeList: this.$Dictionaries.bank_services_types,
      letterCreditTypeList: this.$Dictionaries.letter_credit_types,
      marginSourceList: this.$Dictionaries.margin_resources,
      lcTypeList: this.$Dictionaries.trade_lc_types,
      data: undefined,
      loading: false,
      submitting: false,
      bankFetching: false,
      advisingBankFetching: false,
      bankList: [],
      issuingBankId: undefined,
      accordingContract: true,
      selectedLetterCreditType: 0,
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      }
    }
  },
  mounted () {
    this.loadSellContractInfo()
  },
  computed: {
    formItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 6 },
          wrapperCol: { span: 18 }
        } : {}
    },
    buttonItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 3 },
          wrapperCol: { span: 21 }
        } : {}
    },
    selectedSellContract () {
      if (this.data === undefined) {
        return ''
      }
      return this.data.sell_contract.name + '[' + this.data.sell_contract.number + ']'
    },
    selectedProject () {
      if (this.data === undefined) {
        return ''
      }
      return this.data.project
    }
  },
  methods: {
    moment,
    handleGoBack () {
      // this.$emit('onGoBack')
      this.$router.go(-1)
    },

    loadSellContractInfo () {
      this.loading = true
      console.log('开始加载。。。。。', this.$route.params.id, '===', this.$route.query.lc_application_id)
      lc_application_list({ id: this.$route.query.lc_application_id })
        .then(res => {
          this.mdl = res.data.entries[0] || []
          console.log('信用证开始binaji', this.mdl)
        }).finally(() => {
        if (this.mdl !== undefined && this.mdl['sell_contract_id'] !== undefined) {
          sell_contract_list({ id: this.mdl['sell_contract_id'] }).then(res => {
            if (res !== undefined && res.code === 1000 && res.data !== undefined && res.data.entries !== undefined && res.data.entries.length > 0) {
              this.sellContract = res.data.entries[0]
            }
          }).finally(() => {
            this.loading = false
            if (this.sellContract) {
              // 信用证是否已开具，开具的话，获取已开具的
              // this.otherData['beneficiary_id'] = this.sellContract.client_ids[0]
            }
          })
          lc_issuance_list({ id: this.$route.params.id }).then(res => {
            if (res !== undefined && res.code === 1000 && res.data !== undefined && res.data.entries !== undefined && res.data.entries.length > 0) {
              const currentData = res.data.entries[0]
              if (currentData) {
                currentData.lc_type = '' + currentData.lc_type
                this.loadEditInfo(currentData)
              }
            }
          })
        } else {
          this.loading = false
        }
      })
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        console.log('我要提交接口', values)
        if (!err) {
          this.loading = true
          this.submitting = true
          lc_issuance_update(values, this.id)
            .then((res) => {
              this.handleGoBack()
              console.log(res, '修改成功')
            }).finally(() => {
              this.loading = false
              this.submitting = false
          })
        }
      })
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    loadEditInfo (data) {
      const { form } = this
      console.log(`将加载 ${this} 信息到表单`)
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        const formData = pick(data, fields)
        formData.bank_services_type = '' + formData.bank_services_type
        formData.letter_credit_type = '' + formData.letter_credit_type
        formData.margin_source = '' + formData.margin_source
        if (formData.issue_date === '1970-01-01') {
          formData.issue_date = undefined
        }
        if (formData.margin_deposit_date === '1970-01-01') {
          formData.margin_deposit_date = undefined
        }
        if (formData.margin_maturity_date === '1970-01-01') {
          formData.margin_maturity_date = undefined
        }
        console.log('formData', formData)
        this.id = formData.id
        formData.type = String(formData.type)
        form.setFieldsValue(formData)
      }).finally(() => {
        if (data.debtor_bank_id) {
          this.backLoadList({ id: data.debtor_bank_id }, 1)
        }
      })
    },
    handleBankSearch (value) {
      this.backLoadList({ name: value }, 1)
    },
    backLoadList (parameter, index) {
      if (index === 1) {
        this.bankFetching = true
      } else {
        this.advisingBankFetching = true
      }
      bank_list(parameter).then((res) => {
        if (index === 1) {
          this.bankList = res.data.entries || []
        } else {
          this.advisingBankList = res.data.entries || []
        }
      }).finally(() => {
        if (index === 1) {
          this.bankFetching = false
        } else {
          this.advisingBankFetching = false
        }
      })
    },
    handleAccordingContractChange (value) {
      this.accordingContract = value
    },
    handleLetterCreditTypeChange (value) {
      this.selectedLetterCreditType = value
    }
  }
}
</script>
